/**
 * Calculate Screen
 *
 * Entry point for running the full analysis pipeline. Loads the
 * project by ID from the URL params, verifies a master frame exists,
 * then lets the user launch the RunAnalysis modal which triggers
 * all server-side computations (aging, rollforward, supplier metrics,
 * invoice eligibility, criteria, advance rates, performance).
 */
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
// ------------------------------------------------------------
import RunAnalysis from "Components/RunAnalysis";
import { loadProject } from "Redux/project/actions";
import waitbar from "Media/waitbar.gif";
// ------------------------------------------------------------
// ------------------------------------------------------------
const Calculate = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(false);
  const project = useSelector((state) => state.project);

  const { pid } = useParams();
  useEffect(() => {
    setLoading(true);
    dispatch(
      loadProject(pid, () => {
        setLoading(false);
      })
    )
  }, [pid, dispatch]);

  if(loading) return <div><img src = {waitbar } alt="Loading" /></div>;
  if (!project) return null;

  if(!project.hasMaster) {
    return(
      <div className = "notification is-warning is-light">
        This project does not have a master frame yet.
      </div>
    )
  }


  return (
    <div>
      {progress && <RunAnalysis onClose = {() => setProgress(false)} />}
      <button className = "button is-small" onClick = {() => setProgress(true)}>
        <span className = "icon">
          <i className = "fas fa-cogs"></i>
        </span>
        <span>Generate Analysis</span>
      </button>
    </div>
  );
};

export default Calculate;